module.exports = __webpack_public_path__ + "static/media/day_five.4f274dbe.jpg";